var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import produce from 'immer';
import * as React from 'react';
import { createContext, useEffect, useReducer, useState } from 'react';
import { getConfig, getUserManager } from '../Config/ApplicationConfig';
import { routerHistory } from './history';
import { useApplicationIdleHandler } from './useApplicationIdleHandler';
// Log.logger = console;
// Uncomment to turn on detailed debug information
// Log.level = Log.DEBUG;
export var AuthenticationStatus;
(function (AuthenticationStatus) {
    AuthenticationStatus["Init"] = "Init";
    AuthenticationStatus["Authenticating"] = "Authenticating";
    AuthenticationStatus["Authenticated"] = "Authenticated";
    AuthenticationStatus["Errored"] = "Errored";
    AuthenticationStatus["LoggedOut"] = "LoggedOut";
})(AuthenticationStatus || (AuthenticationStatus = {}));
var authenticated;
var silentlyAuthenticateAndFetchUser = function () { return __awaiter(void 0, void 0, void 0, function () {
    var silentUser, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                console.log('Attempting silent sign in');
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                console.log('Doing silent sign in');
                return [4 /*yield*/, getUserManager().signinSilent()];
            case 2:
                silentUser = _a.sent();
                if (silentUser) {
                    console.log('Silent sign in successful');
                    return [2 /*return*/, silentUser];
                }
                console.log('Unable to do silent sign in');
                return [2 /*return*/, null];
            case 3:
                err_1 = _a.sent();
                console.error('Silent signing error - Unable to do silent sign in: ', err_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
export function getAuthAccessToken() {
    return __awaiter(this, void 0, void 0, function () {
        var userManager, user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userManager = getUserManager();
                    if (!userManager) return [3 /*break*/, 2];
                    return [4 /*yield*/, userManager.getUser()];
                case 1:
                    user = _a.sent();
                    if (user) {
                        return [2 /*return*/, user.access_token];
                    }
                    _a.label = 2;
                case 2:
                    console.error('User token was requested when no user is stored');
                    return [2 /*return*/, ''];
            }
        });
    });
}
export function getUserId() {
    return __awaiter(this, void 0, void 0, function () {
        var userManager, user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userManager = getUserManager();
                    if (!userManager) return [3 /*break*/, 2];
                    return [4 /*yield*/, userManager.getUser()];
                case 1:
                    user = _a.sent();
                    if (user) {
                        return [2 /*return*/, user.profile.sub];
                    }
                    _a.label = 2;
                case 2:
                    console.error('User token was requested when no user is stored');
                    return [2 /*return*/, ''];
            }
        });
    });
}
export function getAuthToken() {
    return __awaiter(this, void 0, void 0, function () {
        var userManager, user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userManager = getUserManager();
                    if (!userManager) return [3 /*break*/, 2];
                    return [4 /*yield*/, userManager.getUser()];
                case 1:
                    user = _a.sent();
                    if (user) {
                        return [2 /*return*/, user.token_type + " " + user.access_token];
                    }
                    _a.label = 2;
                case 2:
                    console.error('User token was requested when no user is stored');
                    return [2 /*return*/, ''];
            }
        });
    });
}
export function validateOrRenewUser() {
    return __awaiter(this, void 0, void 0, function () {
        var managersUser, renewedUser;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getUserManager().getUser()];
                case 1:
                    managersUser = _a.sent();
                    if (!(!managersUser || (!!managersUser && managersUser.expired))) return [3 /*break*/, 3];
                    return [4 /*yield*/, silentlyAuthenticateAndFetchUser()];
                case 2:
                    renewedUser = _a.sent();
                    if (renewedUser) {
                        authenticated(renewedUser);
                        return [2 /*return*/, renewedUser];
                    }
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/, managersUser];
            }
        });
    });
}
export function useUserInformation() {
    var _this = this;
    var _a = __read(useState({
        userId: '',
        status: 'init'
    }), 2), user = _a[0], setUser = _a[1];
    var getUser = function () { return __awaiter(_this, void 0, void 0, function () {
        var userId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setUser(function (user) { return (__assign(__assign({}, user), { status: 'loading' })); });
                    return [4 /*yield*/, getUserId()];
                case 1:
                    userId = _a.sent();
                    setUser({
                        userId: userId,
                        status: 'loaded'
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getUser();
    }, []);
    return {
        user: user
    };
}
var authenticationReducer = produce(function (state, actions) {
    switch (actions.type) {
        case 'Authenticate':
            state.status = AuthenticationStatus.Authenticating;
            break;
        case 'Authenticated':
            state.status = AuthenticationStatus.Authenticated;
            state.error = '';
            break;
        case 'ErrorAuthenticating':
            state.status = AuthenticationStatus.Errored;
            state.error = actions.error;
            break;
    }
});
function reloadApplicationUrl() {
    var redirectUrl = window.sessionStorage.getItem('redirectUrl');
    if (!!redirectUrl && !!routerHistory && routerHistory.push) {
        routerHistory.push(redirectUrl);
        window.sessionStorage.removeItem('redirectUrl');
        console.log('Reloading url: ', redirectUrl);
    }
}
export function saveApplicationUrl(overrideUrl) {
    var redirectUrl = overrideUrl !== null && overrideUrl !== void 0 ? overrideUrl : window.location.pathname + window.location.search;
    if (window.location.pathname !== '/login') {
        window.sessionStorage.setItem('redirectUrl', redirectUrl);
        console.log('Storing url: ', redirectUrl);
    }
}
export var AuthenticationContext = createContext({
    status: AuthenticationStatus.Init,
    error: '',
    authenticate: function () {
        throw new Error('No authentication context found');
    }
});
export var ApplicationAuthentication = function (_a) {
    var _b;
    var manager = _a.manager, children = _a.children;
    var userLoggedOut = document.location && document.location.hash.indexOf('logged_out') >= 0;
    var _c = __read(useReducer(authenticationReducer, {
        status: userLoggedOut ? AuthenticationStatus.LoggedOut : AuthenticationStatus.Init,
        error: ''
    }), 2), state = _c[0], dispatch = _c[1];
    var signIn = function () { return __awaiter(void 0, void 0, void 0, function () {
        var user, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: 'Authenticate' });
                    console.log('No id_token found in URL, looking for user.');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 8, , 9]);
                    return [4 /*yield*/, manager.getUser()];
                case 2:
                    user = _a.sent();
                    if (!(!!user && !user.expired)) return [3 /*break*/, 3];
                    console.log('Successful call to get user');
                    dispatch({ type: 'Authenticated', user: user });
                    return [2 /*return*/];
                case 3: return [4 /*yield*/, silentlyAuthenticateAndFetchUser()];
                case 4:
                    user = _a.sent();
                    console.log('Successfully fetched user silently');
                    if (user) {
                        reloadApplicationUrl();
                        dispatch({ type: 'Authenticated', user: user });
                        return [2 /*return*/];
                    }
                    _a.label = 5;
                case 5:
                    if (!!user) return [3 /*break*/, 7];
                    console.log('No user found, calling sign in');
                    saveApplicationUrl();
                    return [4 /*yield*/, manager.signinRedirect()];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    err_2 = _a.sent();
                    console.error('Error with Authenticate: ', err_2);
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    authenticated = function (user) {
        dispatch({ type: 'Authenticated', user: user });
    };
    var processToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var user, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, silentlyAuthenticateAndFetchUser()];
                case 1:
                    user = _a.sent();
                    if (!user) return [3 /*break*/, 2];
                    console.log('Successfully fetched user silently');
                    reloadApplicationUrl();
                    dispatch({ type: 'Authenticated', user: user });
                    return [2 /*return*/];
                case 2: return [4 /*yield*/, manager.signinRedirectCallback()];
                case 3:
                    user = _a.sent();
                    if (user) {
                        reloadApplicationUrl();
                        dispatch({ type: 'Authenticated', user: user });
                    }
                    else {
                        console.log('No user found: ', user);
                        dispatch({ type: 'ErrorAuthenticating', error: 'No user found' });
                    }
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    err_3 = _a.sent();
                    console.error('Error processing token: ', err_3);
                    if (typeof err_3 === 'string') {
                        dispatch({ type: 'ErrorAuthenticating', error: err_3 });
                    }
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var processError = function (error) {
        dispatch({ type: 'ErrorAuthenticating', error: error });
    };
    var authenticate = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (document && document.location) {
                if (userLoggedOut) {
                    return [2 /*return*/];
                }
                else if (document.location.hash.indexOf('id_token') >= 0) {
                    // Token found, processing.
                    processToken();
                }
                else if (document.location.hash.indexOf('error') >= 0) {
                    processError('Authentication Error');
                }
                else {
                    // No Token found, firing off authenticationState.
                    signIn();
                }
            }
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        var userManagerEvents = getUserManager().events;
        userManagerEvents.addSilentRenewError(function (err) {
            console.log('Silent authenticationState renewal failed. If this continues then the access token may expire.', err.message);
        });
        userManagerEvents.addAccessTokenExpiring(function () {
            console.log('The access token is expiring.');
        });
        userManagerEvents.addAccessTokenExpired(function () {
            console.log('The access token has expired.');
        });
        userManagerEvents.addUserSignedOut(function () {
            console.log('User has been signed out, possibly in another tab. Logging them out.');
            manager.signoutRedirect();
        });
        userManagerEvents.addUserLoaded(function (user) {
            console.log('User session has been loaded.');
            authenticated(user);
        });
        userManagerEvents.addUserUnloaded(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            console.log('User unloaded - args: ', args);
        });
        userManagerEvents.addUserSessionChanged(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            console.log('User Session Changed - args: ', args);
        });
        userManagerEvents.addUserSignedOut(function () {
            console.log('Signed out');
        });
    }, []);
    var signUserOut = function () {
        manager.signoutRedirect();
    };
    var maxTimeoutInMinutes = (_b = getConfig().automaticLogoutMinutes) !== null && _b !== void 0 ? _b : 15;
    useApplicationIdleHandler({
        maxTimeoutInMinutes: maxTimeoutInMinutes,
        signout: signUserOut,
        userLoggedOut: userLoggedOut,
        setApplicationReloadUrl: saveApplicationUrl
    });
    return (React.createElement(AuthenticationContext.Provider, { value: __assign(__assign({}, state), { authenticate: authenticate }) }, children));
};
